import React from "react";
import {PageController} from "../../../../components/PageController";
import UserScale from "../UserScale";
import Gender from "../Gender";
import {CurrentBodyType} from "../CurrentBodyType/CurrentBodyType";
import {Height} from "../Height/Height";
import AgeRange from "../AgeRange";
import {ActivityLevel} from "../ActivityLevel";
import {HealthConcerns} from "../HealthConcerns";
import {TargetBodyType} from "../TargetBodyType";
import {CurrentWeight} from "../CurrentWeight";
import {TargetWeight} from "../TargetWeight";
import {Age} from "../Age";
import LastingResults from "../LastingResults";
import ProfileSummary from "../ProfileSummary";
import UserPower from "../UserPower";
import CreatingPlan from "../CreatingPlan";
import Email from "../Email";
import UserName from "../UserName";
import {WaterIntake} from "../WaterIntake";
import {MealTime} from "../MealTime";
import {LastMealTime} from "../LastMealTime";
import {MealCount} from "../MealCount";
import {DietaryPreference} from "../DietaryPreference";
import {CraveFood} from "../CraveFood";
import {Habits} from "../Habits";
import {CravingsSupport} from "../CravingsSupport";
import {HeardFasting} from "../HeardFasting";
import {WhatFasting} from "../WhatFasting";
import {MainGoal} from "../MainGoal";
import {FastingSolution} from "../FastingSolution";
import {SkinChanges} from "../SkinChanges";
import {StayYouthful} from "../StayYouthful";
import {NavigationEnum} from "../../../../enum/NavigationEnum";
import {CurrentBodyTypeHook} from "../CurrentBodyType/CurrentBodyTypeHook";
import {TargetBodyTypeHook} from "../TargetBodyType/TargetBodyTypeHook";
import {PayScreen} from "../PayScreen";
import {createQuestionnaireFormData, getQuestionnaireConfigById, QUESTIONNAIRE_IDS} from "../../../../domin/questionnaire/registry";

export const Fasting = () => {
    const questionnaireConfig = getQuestionnaireConfigById(QUESTIONNAIRE_IDS.FASTING);
    const formData = createQuestionnaireFormData(questionnaireConfig);
    return (<PageController
        formData={formData}
        pages={[
            {
                pageId: "ageRange",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: AgeRange
            },
            {
                pageId: "gender",
                navigationStatus: NavigationEnum.NORMAL,
                component: Gender,
            },
            {
                pageId: "userScale",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: UserScale,
                displayBtn: true,
            },
            {
                pageId: "heardFasting",
                navigationStatus: NavigationEnum.NORMAL,
                component: HeardFasting,
            },
            {
                pageId: "whatFasting",
                navigationStatus: NavigationEnum.NORMAL,
                component: WhatFasting,
                displayBtn: true,
            },
            {
                pageId: "mainGoalChoice",
                navigationStatus: NavigationEnum.NORMAL,
                component: MainGoal,
            },
            {
                pageId: "fastingSolution",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: FastingSolution,
                displayBtn: true
            },
            {
                pageId: "currentBodyType",
                navigationStatus: NavigationEnum.NORMAL,
                component: CurrentBodyTypeHook,
            },
            {
                pageId: "targetBodyType",
                navigationStatus: NavigationEnum.NORMAL,
                component: TargetBodyTypeHook,
            },
            {
                pageId: "height",
                navigationStatus: NavigationEnum.NORMAL,
                component: Height,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "currentWeight",
                navigationStatus: NavigationEnum.NORMAL,
                component: CurrentWeight,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "targetWeight",
                navigationStatus: NavigationEnum.NORMAL,
                component: TargetWeight,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "age",
                navigationStatus: NavigationEnum.NORMAL,
                component: Age,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "lastingResults",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: LastingResults,
                displayBtn: true,
            },
            {
                pageId: "activityLevel",
                navigationStatus: NavigationEnum.NORMAL,
                component: ActivityLevel,
            },
            {
                pageId: "healthConcerns",
                navigationStatus: NavigationEnum.NORMAL,
                component: HealthConcerns,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "profileSummary",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: ProfileSummary,
                displayBtn: true,
            },
            {
                pageId: "mealCount",
                navigationStatus: NavigationEnum.NORMAL,
                component: MealCount,
            },
            {
                pageId: "mealTime",
                navigationStatus: NavigationEnum.NORMAL,
                component: MealTime,
            },
            {
                pageId: "lastMealTime",
                navigationStatus: NavigationEnum.NORMAL,
                component: LastMealTime,
            },
            {
                pageId: "waterIntake",
                navigationStatus: NavigationEnum.NORMAL,
                component: WaterIntake,
            },
            {
                pageId: "dietaryPreference",
                navigationStatus: NavigationEnum.NORMAL,
                component: DietaryPreference
            },
            {
                pageId: "habits",
                navigationStatus: NavigationEnum.NORMAL,
                component: Habits,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "craveFood",
                navigationStatus: NavigationEnum.NORMAL,
                component: CraveFood,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "cravingsSupport",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: CravingsSupport,
                displayBtn: true
            },
            {
                pageId: "skinChanges",
                navigationStatus: NavigationEnum.NORMAL,
                component: SkinChanges,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "stayYouthful",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: StayYouthful,
                displayBtn: true
            },
            {
                pageId: "userPower",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: UserPower,
                displayBtn: true,
            },
            {
                pageId: "creatingPlan",
                navigationStatus: NavigationEnum.NONE,
                component: CreatingPlan,
            },
            {
                pageId: "email",
                navigationStatus: NavigationEnum.NORMAL,
                component: Email,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "userName",
                navigationStatus: NavigationEnum.NORMAL,
                component: UserName,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "pay",
                navigationStatus: NavigationEnum.NONE,
                component: PayScreen,
            }
        ]}
        localStorageKey={questionnaireConfig.localStorageKey}
        mode={questionnaireConfig.mode}
    />)
};
